import React, { useState } from 'react';
import {
  Button,
  Col,
  FlexboxGrid,
  Form,
  IconButton,
  Input,
  InputNumber,
  InputPicker,
  Modal,
  Panel
} from 'rsuite';
import TrashIcon from '@rsuite/icons/Trash';

const cartontype = [
  { label: 'Master', value: 'master' },
  { label: 'Inner', value: 'inner' }
];
const siii = [
  { label: 'CM', value: 'cm' },
  { label: 'Inch', value: 'inch' }
];
const VariantPacking = ({ variantData, setVariantData, cbmeditdata, showModal, setShowModal }) => {  
  const [localPackaging, setLocalPackaging] = useState([
    {
      Total_CBM: 0,
      Total_CFT: 0,
      TwentyFT: '',
      FortyFT: '',
      FortyHQ: '',
      Packaging: [
        {
          CartonType: 'master',
          ProductCode: '0',
          Carton_Unit: 'inch',
          Carton_Length: 0,
          Carton_Width: 0,
          Carton_Thick: 0,
          Carton_CBM: 0,
          Carton_PCS: 0,
          Carton_CBMperpc: 0,
          Carton_GrsWt: 0
        }
      ]
    }
  ]);

  const handleInputChangeForPackaging = (field, value, packagingIndex, rowIndex) => {
    setLocalPackaging(prevData => {
      const updatedPackaging = [...prevData];
  
      // Ensure rowIndex exists
      if (!updatedPackaging[rowIndex]) {
        updatedPackaging[rowIndex] = {
          Total_CBM: 0,
          Total_CFT: 0,
          TwentyFT: '',
          FortyFT: '',
          FortyHQ: '',
          Packaging: []
        };
      }
  
      // Ensure packagingIndex exists in the Packaging array
      if (!updatedPackaging[rowIndex].Packaging[packagingIndex]) {
        updatedPackaging[rowIndex].Packaging[packagingIndex] = {
          CartonType: 'master',
          ProductCode: '0',
          Carton_Unit: 'inch',
          Carton_Length: 0,
          Carton_Width: 0,
          Carton_Thick: 0,
          Carton_CBM: 0,
          Carton_PCS: 0,
          Carton_CBMperpc: 0,
          Carton_GrsWt: 0
        };
      }
  
      // Update the specific field
      if (field.startsWith('Carton')) {
        updatedPackaging[rowIndex].Packaging[packagingIndex] = {
          ...updatedPackaging[rowIndex].Packaging[packagingIndex],
          [field]: value
        };
      } else {
        updatedPackaging[rowIndex] = {
          ...updatedPackaging[rowIndex],
          [field]: value
        };
      }
  
      // Extract relevant values for calculations
      const {
        Carton_Unit: unit,
        Carton_Length: len,
        Carton_Width: wid,
        Carton_Thick: thick,
        Carton_PCS: pcs
      } = updatedPackaging[rowIndex].Packaging[packagingIndex];
  
      // Calculate CBM and CBM per piece
      let productCBM = unit === 'cm'
        ? (len * wid * thick) / 1000000
        : (len * wid * thick) / 61023;
  
      const productCBMPerPc = pcs > 0 ? productCBM / pcs : 0;
  
      // Update calculated values
      updatedPackaging[rowIndex].Packaging[packagingIndex].Carton_CBM = productCBM.toFixed(4);
      updatedPackaging[rowIndex].Packaging[packagingIndex].Carton_CBMperpc = productCBMPerPc.toFixed(4);
  
      // Recalculate totals for the row
      let totalCBM = 0;
      updatedPackaging[rowIndex].Packaging.forEach(pack => {
        if (pack.CartonType === 'master') {
          totalCBM += parseFloat(pack.Carton_CBMperpc) || 0;
        }
      });
  
      updatedPackaging[rowIndex].Total_CBM = totalCBM.toFixed(4);
      updatedPackaging[rowIndex].Total_CFT = (totalCBM * 35.3147).toFixed(4); // Convert CBM to CFT
      updatedPackaging[rowIndex].TwentyFT = totalCBM ? Math.floor(27 / totalCBM).toString() : '0';
      updatedPackaging[rowIndex].FortyFT = totalCBM ? Math.floor(56 / totalCBM).toString() : '0';
      updatedPackaging[rowIndex].FortyHQ = totalCBM ? Math.floor(65 / totalCBM).toString() : '0';
  
      return updatedPackaging;
    });
  };
  

  const handleAddPackaging = rowIndex => {
    setLocalPackaging(prevData => {
      const updatedPackaging = [...prevData];
      // Ensure rowIndex exists
      if (!updatedPackaging[rowIndex]) {
        updatedPackaging[rowIndex] = {
          Total_CBM: 0,
          Total_CFT: 0,
          TwentyFT: '',
          FortyFT: '',
          FortyHQ: '',
          Packaging: []
        };
      }
      updatedPackaging[rowIndex].Packaging.push({
        CartonType: 'master',
        ProductCode: '0',
        Carton_Unit: 'inch',
        Carton_Length: 0,
        Carton_Width: 0,
        Carton_Thick: 0,
        Carton_CBM: 0,
        Carton_PCS: 0,
        Carton_CBMperpc: 0,
        Carton_GrsWt: 0
      });

      return updatedPackaging;
    });
  };

  const handleSavePackaging = () => {
    const updatedVariants = [...variantData];
    if (cbmeditdata >= 0 && updatedVariants[cbmeditdata]) {
      updatedVariants[cbmeditdata] = {
        ...updatedVariants[cbmeditdata],
        ...localPackaging[cbmeditdata]
      };
    }
    setVariantData(updatedVariants);
    setShowModal(false);
  };
  const handleDeletePackaging = (index, cbmeditdata) => {
    const updatedLocalPackaging = [...localPackaging];
    updatedLocalPackaging[cbmeditdata].Packaging.splice(index, 1);
    setLocalPackaging(updatedLocalPackaging);
  };
  return (
    <Modal size="full" open={showModal} onClose={() => setShowModal(false)}>
      <Modal.Body>
        <Panel header="Packaging">
          <div>
            <Form fluid>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={22}>
                  {localPackaging[cbmeditdata]?.Packaging?.map((packaging, index) => (
                    <div key={index}>
                      <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
                        <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                          <Form.ControlLabel>Carton Type</Form.ControlLabel>
                          <InputPicker
                            data={cartontype}
                            value={packaging.CartonType}
                            onChange={event =>
                              handleInputChangeForPackaging('CartonType', event, index, cbmeditdata)
                            }
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                          <Form.ControlLabel>SizeUnit</Form.ControlLabel>
                          <InputPicker
                            data={siii}
                            value={packaging.Carton_Unit}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_Unit',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>Length</Form.ControlLabel>
                          <InputNumber
                            step={null}
                            value={packaging.Carton_Length}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_Length',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                            min={0}
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>Width</Form.ControlLabel>
                          <InputNumber
                            step={null}
                            value={packaging.Carton_Width}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_Width',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                            min={0}
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>Height</Form.ControlLabel>
                          <InputNumber
                            step={null}
                            value={packaging.Carton_Thick}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_Thick',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                            min={0}
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>Box Area</Form.ControlLabel>
                          <Input
                            readOnly
                            value={packaging.Carton_CBMperpc}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_CBMperpc',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>PCS</Form.ControlLabel>
                          <Input
                            value={packaging.Carton_PCS  ? packaging.Carton_PCS : 1}
                            onChange={event =>
                              handleInputChangeForPackaging('Carton_PCS', parseInt(event) || 0, index, cbmeditdata)
                            }
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>CBM</Form.ControlLabel>
                          <Input
                            readOnly
                            value={packaging.Carton_CBM}
                            onChange={event =>
                              handleInputChangeForPackaging('Carton_CBM', event, index, cbmeditdata)
                            }
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                          <Form.ControlLabel>Gross Wt.</Form.ControlLabel>
                          <InputNumber
                            step={null}
                            value={packaging.Carton_GrsWt}
                            onChange={event =>
                              handleInputChangeForPackaging(
                                'Carton_GrsWt',
                                event,
                                index,
                                cbmeditdata
                              )
                            }
                            min={0}
                          />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item as={Col} colspan={24} md={1}>
                        {index > 0 && (
                        <IconButton
                                active
                                style={{ marginTop: '20px' }}
                                onClick={() => handleDeletePackaging(index, cbmeditdata)}
                                icon={<TrashIcon />}
                              />
                            )}
                        </FlexboxGrid.Item>
                      </FlexboxGrid>
                    </div>
                  ))}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={2}>
                  <Button
                    active
                    onClick={() => handleAddPackaging(cbmeditdata)}
                    style={{ marginTop: '20px' }}
                  >
                    Add Row
                  </Button>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </div>
        </Panel>
        <Panel header="Loadability">
          <div>
            <Form fluid>
              <FlexboxGrid justify="space-around" style={{ marginBottom: '10px' }}>
                <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                  <Form.ControlLabel>Total CBM</Form.ControlLabel>
                  <Input
                    value={localPackaging[cbmeditdata]?.Total_CBM || 0}
                    onChange={event =>
                      handleInputChangeForPackaging('Total_CBM', event, -1, cbmeditdata)
                    }
                  />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                  <Form.ControlLabel>Total CFT</Form.ControlLabel>
                  <Input
                    value={localPackaging[cbmeditdata]?.Total_CFT || 0}
                    onChange={event =>
                      handleInputChangeForPackaging('Total_CFT', event, -1, cbmeditdata)
                    }
                  />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                  <Form.ControlLabel>20FT</Form.ControlLabel>
                  <Input
                    value={localPackaging[cbmeditdata]?.TwentyFT || ''}
                    onChange={event =>
                      handleInputChangeForPackaging('TwentyFT', event, -1, cbmeditdata)
                    }
                  />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                  <Form.ControlLabel>40FT</Form.ControlLabel>
                  <Input
                    value={localPackaging[cbmeditdata]?.FortyFT || ''}
                    onChange={event =>
                      handleInputChangeForPackaging('FortyFT', event, -1, cbmeditdata)
                    }
                  />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item as={Col} colspan={24} md={3}>
                  <Form.ControlLabel>40HQ</Form.ControlLabel>
                  <Input
                    value={localPackaging[cbmeditdata]?.FortyHQ || ''}
                    onChange={event =>
                      handleInputChangeForPackaging('FortyHQ', event, -1, cbmeditdata)
                    }
                  />
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </div>
        </Panel>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleSavePackaging} appearance="primary" color="cyan">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VariantPacking;
